
<img class="top-padding" id='SI-logo' (click)="setPage(1)" src="assets/images/SI-logo.png">

<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr>




  <button
  type="button"
  class='typeButton btn btn-outline-primary'
  (click)=setPage(2)>
  Founder Profile 創始人簡介

  </button>

  <button
  type="button"
  class='typeButton btn btn-outline-primary'
  (click)=setPage(3)>
  COVID-19 Project 抗疫基金概要
  </button>

  <button
  type="button"
  class='typeButton btn btn-outline-primary'
  (click)=setPage(4)>
  Zephy 無濾網空氣消毒機
  </button>

  <br/>

  <div *ngIf='page == 1'>
    <img class="splashh" src="assets/images/smart_l.png" width="100%" />
    <img class="splashv" src="assets/images/smart_p.png" width="100%" />
  </div>

  <div *ngIf='page == 2'>
    <div class="container">
      <app-who-are></app-who-are>
    </div>
  </div>

  <div *ngIf='page == 3'>
    <div class="container">

      <app-covid></app-covid>
    </div>
  </div>

  <div *ngIf='page == 4'>
    <img src="assets/images/zephy-01.png" width="100%" />
    <img src="assets/images/zephy-02.png" width="100%" />
    <img src="assets/images/zephy.png" width="100%" />
    <!-- <img class="splashv" src="assets/images/zephy-02.png" width="100%" /> -->
  </div>
